import { CardSkeletonLoader } from 'app/components/CardSkeletonLoader';
import React from 'react';
import styled from 'styled-components';

interface MetricCardProps {
  title: string;
  amount: string | number;
  onClick?: () => void;
  loading?: boolean;
  iconSvg: string
}

const CardContainer = styled.div`
  text-align: center;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #EAECF0;
  background-color: #F7F7F7;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 23px;
  min-height: 116px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #030229;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  white-space: nowrap;
  text-align: left;
`;

const DashboardContainer = styled.div`
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const Value = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #030229;
  text-align: left;
`;
export const AmountCard: React.FC<MetricCardProps> = ({
  amount,
  title,
  onClick,
  loading,
  iconSvg
}) => {
  if (loading) {
    return (
      <DashboardContainer>
        <GridContainer>
          <CardSkeletonLoader
            isHeaderLoader
            headerWidth={297}
            headerHeight={102}
          />
          {/* <LoadingCard /> */}
        </GridContainer>
      </DashboardContainer>
    );
  }

  return (
    <CardContainer onClick={onClick}>
      <img src={iconSvg} />
      <div>
        <Value>{amount}</Value>
        <Title>{title}</Title>
      </div>
    </CardContainer>
  );
};


